<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">套餐购买记录</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="店铺号:">
              <!-- <el-input v-model="formInline.code" placeholder="请输入店铺号"></el-input> -->
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入店铺号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.storeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="店铺名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入店铺名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.shopName" :value="item.storeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="套餐名称:">
              <el-input v-model="formInline.planName" placeholder="请输入套餐名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="店铺类型:">
              <el-select v-model="formInline.storeTypeid" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="购买日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable align="left" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, searchPlateform(queryInfo)" round>查询</el-button>
            <!-- <el-button class="search-ok" v-if="$hasPermission('crm:admin:store:export')" v-permission="'crm:admin:store:export'" @click="exportExcel" round>导出Excel</el-button>
            <el-button class="search-ok" round type="primary" v-if="$hasPermission('crm:admin:store:apply')" v-permission="'crm:admin:store:apply'" @click="applyplatform"> 申请店铺 </el-button> -->
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @size-change="sizeChange">
          <el-table-column prop="orderNo" label="流水号" min-width="10px"></el-table-column>
          <el-table-column prop="storeCode" label="店铺号" min-width="10px"></el-table-column>
          <el-table-column prop="storeName" label="店铺名称" min-width="10px"></el-table-column>
          <el-table-column prop="salesmanName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="storePhone" label="手机号" min-width="10"></el-table-column>
          <el-table-column prop="planName" label="套餐名称" min-width="10"></el-table-column>
          <el-table-column prop="amount" label="套餐价格" min-width="10"></el-table-column>
          <el-table-column prop="amountReal" label="实付金额" min-width="10"></el-table-column>
          <el-table-column prop="paymentDate" label="购买日期" min-width="10"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getMemberShipOrderList, storeTypeGetStoreTypeList, storeExport, getSalesmanByFullName, getMembershipListForQuery } from '@/api/crm'
export default {
  name: 'platform-message',
  components: {
    VPagination
  },
  data () {
    return {
      formInline: {
        code: '',
        storeName: '',
        salename: '',
        phone: '',
        auditStatus: '',
        startTime: '',
        endTime: '',
        storeTypeid: ''
      },
      salemanList: [],
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      platformType: [],
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      value2: [
        this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      storeListByCode: []
    }
  },
  watch: {
    $route: {
      handler: function (newRoute, oldRoute) {
        console.log('当前路由：', newRoute)
        console.log('之前的路由：', oldRoute)
        if (newRoute.path == '/piya/purchaseRecord') {
          this.formInline.systemCode = 'PIYA'
        } else {
          this.formInline.systemCode = ''
        }
        if (oldRoute && (oldRoute.path == '/piya/purchaseRecord' || oldRoute.path == '/videoSeason/purchaseRecord')) {
          this.searchPlateform(this.queryInfo)
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    },
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.startTime = val[0]
          this.formInline.endTime = val[1]
        } else {
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    console.log('页面加载')
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.startTime, this.formInline.endTime]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('salemanList')
    }
    if (this.$route.query.auditStatus === 'PENDING') {
      this.formInline.auditStatus = 'PENDING'
    }
    this.getPlatformType()
    this.searchPlateform(this.queryInfo)
  },
  // 离开列表页销毁标识
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        getMembershipListForQuery({ name: val }).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    chack (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/shop/detail', query: { id: row.id } })
    },
    examine (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/checkplatform', query: { id: row.id, code: row.code } })
    },
    edit (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/editplatform', query: { id: row.id, auditStatus: row.auditStatus } })
    },
    filterMethod (val) {
      if (val.trim()) {
        getMembershipListForQuery({ code: val }).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    // 从cookie中获取之前存入的参数
    // data为指定页面的路由，当从指定页面返回到当前页面时才到cookie中获取上一次存入的参数 。
    getCookie (data) {
      if (data === '/checkplatform' || data === '/editplatform') {
        let name = this.$route.path
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        // if (arr === document.cookie.match(reg)) {
        this.formInline = this.$qs.parse(arr[2])
        if (this.formInline.platformTypeid !== '') {
          this.formInline.platformTypeid = parseInt(this.formInline.platformTypeid)
        }
        // }
      }
    },
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    },
    searchPlateform (val) {
      // 设置参数
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      getMemberShipOrderList({ pageNum: val.pageNum, pageSize: val.pageSize, storeVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchPlateform(this.queryInfo)
    },
    deleteEmptyProperty (object) {
      for (var i in object) {
        var value = object[i]
        if (typeof value === 'object') {
          if (Array.isArray(value)) {
            if (value.length === 0) {
              delete object[i]
              continue
            }
          }
          this.deleteEmptyProperty(value)
          if (this.isEmpty(value)) {
            delete object[i]
          }
        } else {
          if (value === '' || value === null || value === undefined) {
            delete object[i]
          } else {
          }
        }
      }
      return object
    },
    getPlatformStatus (scope, e) {
      let status = e.target.innerText
      if (status === '审核') {
        this.$router.push({
          path: '/checkplatform',
          query: {
            id: scope.id,
            code: scope.code
          }
        })
      }
      if (status === '查看/编辑') {
        this.$router.push({
          path: '/editplatform',
          query: {
            id: scope.id
          }
        })
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _this = this
      storeExport(_this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '店铺信息表' + '.xls'
          if (this.value2.length) {
            _fileName = '店铺信息表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    applyplatform () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({
        path: '/platformInformation',
        query: { selected: '2' }
      })
    },
    sizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize
      this.getPageData()
    },
    pageIndexChange (pageIndex) {
      this.queryInfo.pageNum = pageIndex
      this.getPageData()
    },
    getPageData () {
      this.queryInfo.total = Math.ceil(this.queryInfo.total / this.queryInfo.pageSize)
      this.tableData = this.tableData.slice(this.queryInfo.pageSize * (this.queryInfo.pageNum - 1), this.queryInfo.pageSize * this.queryInfo.pageNum)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
